import "./footer.css";
function Footer() {
  return (
    <footer className="footer-wrapper background-lightgray">
      <div className="footer-data">
        <h3>Contact</h3>
        <p>I am looking for work! Connect with me here.</p>
        <div className="contact-links">
          <a href="https://www.linkedin.com/in/kylevhuang461/">
            <i className="fa-brands fa-linkedin"></i>
          </a>
          <a href="https://github.com/kvh8899">
            <i className="fa-brands fa-github"></i>
          </a>
          <a href="https://angel.co/u/kyle-huang-7">
            <i className="fa-brands fa-angellist"></i>
          </a>
          <a href="mailto:kylevhuang@gmail.com">
            <i className="fa-solid fa-envelope"></i>
          </a>
        </div>
      </div>
      <div className="bottom-footer" id="contact">
        <p>Website written by Kyle Huang</p>
        <div className="about-web">
          <p>Built with</p>
          <div>
            <i className="fa-brands fa-react"></i>
            <i className="fa-brands fa-js"></i>
            <i className="fa-brands fa-css3-alt"></i>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
